import BHowOrderRussianBox from './BHowOrderRussianBox'

export default BHowOrderRussianBox
